import legends from "./legends";
import timers from "./timers";

const scores = {
  name: "scores",
  data() {
    return {
      home: "",
      away: "",
      legends: "",
      legend: "",
      timer: "",
      timers: "",
      scores: {},
      scoreSet: false,
    };
  },

  watch: {
    scores: function(val) {
      if (!val) return;

      this.home = val[0].home_score;
      this.away = val[0].away_score;
      this.scoreSet = true;

      // console.log(val)
      let period = val[0].period;
      this.legend = this.legends[period];

      let time = val[0].time;
      this.timer = this.timers(time);
    },

    // Live
    $route(newRoute, oldRoute) {
      if (newRoute.params.event !== oldRoute.params.event) {
        this.timer = "";
      }
    },
  },

  mounted() {
    const { params, query } = this.$route;
    if (query.liveEvent) {
      this.initScore(params.sport);
    }
  },

  methods: {
    initScore: function(id_sport) {
      this.legends = legends[id_sport];
      this.timers = timers[id_sport];
    },
  },
};

export default scores;
